<div class="grid max-h-10rem overflow-y-auto time-grid">
  <div
    *ngFor="let slot of availableTimeSlots"
    class="col-3 time-grid-item"
    (click)="onSelectTime(slot)"
  >
    <div
      class="border-round-lg px-2 py-1 flex justify-content-center hover:bg-gray-100 cursor-pointer"
      [ngClass]="{
        'bg-blue-50 border-blue-400 border-2 text-blue-500': isSameTime(
          slot.startTime,
          selectedTime
        ),
        'bg-white border-gray-400 border-1': !isSameTime(slot.startTime, selectedTime)
      }"
    >
      <p>
        <span>{{ slot.startTime | datex : 'HH:mm' }}</span> -
        <span>{{ addHours(slot.startTime, 1) | datex : 'HH:mm' }}</span>
      </p>
    </div>
  </div>
</div>
